import React from 'react';
import RamblaLogo from 'assets/img/rambla-icon.png';
import { BadgeWithIcon, Button } from 'components';
import { Image } from 'react-bootstrap';
import { useUserTourStore } from 'stores/userTourStore';
import styled from 'styled-components';
import { ReactComponent as CloseIcon } from '../../assets/svg/close.svg';

export const UserTourTooltip = (props) => {
  const { backProps, closeProps, continuous, index, primaryProps, skipProps, step, tooltipProps } =
    props;
  const steps = useUserTourStore((state) => state.steps);
  const stepIndex = useUserTourStore((state) => state.stepIndex);

  return (
    <Container {...tooltipProps}>
      <CloseButton {...closeProps}>
        <CloseIcon />
      </CloseButton>
      <StepCounterWrapper>
        <BadgeWithIcon Icon={<Image src={RamblaLogo} width={30} height={30} />}>
          <span>
            {stepIndex + 1} | {steps.length}
          </span>
        </BadgeWithIcon>
      </StepCounterWrapper>
      <ContentContainer>
        {step.title && <Title>{step.title}</Title>}
        <Content $isTitle={!!step.title}>{step.content}</Content>
      </ContentContainer>
      <Footer>
        <Button variant="white" {...skipProps}>
          {skipProps.title}
        </Button>
        <ButtonGroup>
          {index > 0 && (
            <Button variant="white" {...backProps}>
              {backProps.title}
            </Button>
          )}
          {continuous && (
            <Button variant="primary" {...primaryProps}>
              {primaryProps.title}
            </Button>
          )}
        </ButtonGroup>
      </Footer>
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  min-width: 400px;
  min-height: 150px;
  max-width: 500px;
  padding: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: 10px;
  color: #333;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  background-color: white;
  border: 1px solid #d2dded;
`;

const StepCounterWrapper = styled.div`
  position: absolute;
  left: 4px;
  top: 4px;
`;

const CloseButton = styled.button`
  position: absolute;
  right: 4px;
  top: 4px;
  padding: 0;
  font-size: 18px;
  border: none;
  cursor: pointer;
  background-color: transparent;
  color: #d2dded;
  &:hover {
    color: #ccc;
  }
`;
const ContentContainer = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px;
  }
`;
const Title = styled.h4`
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: bold;
  color: #333;
  text-align: center;
`;

const Content = styled.div`
  margin-top: ${({ $isTitle }) => ($isTitle ? '0' : '20px')};
  width: 100%;
  font-size: 16px;
  text-align: left;

  p {
    margin: 0;
    padding: 0;
  }

  p + p {
    margin-top: 8px;
  }

  ul {
    margin: 14px 0 0;
    padding: 0;
    display: grid;
    gap: 8px;
    list-style: none;
  }

  li {
    display: grid;
    grid-template-columns: 8px 1fr;
    column-gap: 10px;
    align-items: start;
  }

  li::before {
    content: '';
    width: 6px;
    height: 6px;
    margin-top: 8px;
    border-radius: 50%;
    background-color: #be1622;
  }
`;

const Footer = styled.div`
  margin-top: auto;
  padding: 0 8px 8px 8px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
`;
